// import {
//   Search20,
//   Notification20,
//   Settings20,
//
// } from "@carbon/icons-react";
import { useCallback, useState } from "react";
import DropdownMenu from "./DropdownMenu/DropdownMenu";

import settingIco from "assets/images/icons/setting-solid.svg";
import nofifyIco from "assets/images/icons/notification-solid.svg";
import Avatar, { ConfigProvider } from "react-avatar";
import logDXG from "assets/images/logo-dxg-no-bg.svg";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu as DropdownMenuReactStrap,
} from "reactstrap";
import { listApp } from "components/HorizontalLayout/Header/list-app";
import React from "react";
import { Button } from "react3l-ui-library";
import { SendAlt16 } from "@carbon/icons-react";

export interface LandingPageHeaderProps {
  isShowDrawer?: boolean;
  handleClick?: () => void;
}

function LandingPageHeader(props: LandingPageHeaderProps) {
  const user = JSON.parse(localStorage.getItem("currentUserInfo"));

  const [isShowAccountDropdown, setIsShowAccountDropdown] =
    useState<boolean>(false);
  const handleShowAccountDropdown = useCallback(() => {
    setIsShowAccountDropdown(true);
  }, []);

  const s3CompanyLogoUrl = `${process.env.REACT_APP_LOGO_WEB}/${user?.businessArea?.code}.png`;
  const handleError = (event: any) => {
    const img = event.target;

    img.src = logDXG;

    img.alt = "Image failed to load";
  };
  const [siteDrop, setSiteDrop] = React.useState(false);
  const handleToggerSite = React.useCallback(() => {
    setSiteDrop(!siteDrop);
  }, [siteDrop]);

  const handleMouseLeaveAll = React.useCallback(() => {
    setSiteDrop(false);
  }, []);

  const handleClickApp = React.useCallback((link: string) => {
    window.open(link, "_blank");
  }, []);

  function renderAppItem() {
    const list: any[] = [];
    listApp.forEach((app, index) => {
      list.push(
        <div key={index}>
          <div
            className="box-item-nav"
            onClick={() => handleClickApp(app.linkApp)}
          >
            <div className="app-title">{app.appName}</div>
            <div className="box-image">
              <img src={app?.src} alt={app.appName} width={80} height={80} />
            </div>
          </div>
          <div className="dropdown-divider"></div>
        </div>
      );
    });

    return <div>{list}</div>;
  }
  return (
    <>
      <div className="login-header__wrapper p-y--xs">
        <div className="d-flex h-100 align-items-center">
          <div className="login-header__logo p-x--lg">
            <div>
              <a href={process.env.REACT_APP_ADMIN_URL || "/landing-page"}>
                <img
                  src={s3CompanyLogoUrl}
                  alt={"datxanh.com.vn"}
                  height={"32"}
                  onError={handleError}
                />
              </a>
            </div>
          </div>
        </div>
        <div className="login-header__list-icon p-x--lg">
          <div className="login-header__icon login-header__icon-notification d-flex align-items-center justify-content-center">
            <span>
              <img src={nofifyIco} alt={"Notifications"} />
            </span>
          </div>
          <div className="login-header__icon login-header__icon-setting d-flex align-items-center justify-content-center">
            <span>
              <img src={settingIco} alt={"Settings"} />
            </span>
          </div>
          <Dropdown
            isOpen={siteDrop}
            toggle={handleToggerSite}
            className={"dxg-dropdown"}
          >
            <DropdownToggle
              id="page-header-user-dropdown"
              className="btn"
              tag="button"
              style={{ boxShadow: "none" }}
            >
              <div className="btn-switch-subsystem">
                <Button
                  type="secondary"
                  className="btn--lg btn-orange-export"
                  icon={<SendAlt16 />}
                >
                  Chuyển phân hệ
                </Button>
              </div>
            </DropdownToggle>
            <DropdownMenuReactStrap
              className={`dropdown-menu-end p-l--xxs dropdown__list-item`}
            >
              <div className="dropdown__list__landing__page">
                <div
                  className={`${siteDrop ? "active" : ""}`}
                  onMouseLeave={handleMouseLeaveAll}
                >
                  {renderAppItem()}
                </div>
              </div>
            </DropdownMenuReactStrap>
          </Dropdown>
          <div
            className={`login-header__icon login-header__icon-user d-flex align-items-center justify-content-center ${
              isShowAccountDropdown ? "active-item" : ""
            }`}
            onClick={handleShowAccountDropdown}
          >
            <button
              type="button"
              className="btn header-item waves-effect d-flex align-items-center"
              id="page-header-user-dropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <div className={"d-inline-block text-right p-r--xs"}>
                <span className="d-none d-xl-inline-block user-info-btn">
                  <strong className={"d-block"}>{user?.displayName}</strong>
                  <small className={"text-muted"}>
                    {user?.jobTitle || "N/A"}
                  </small>
                </span>
              </div>

              {user?.avatar ? (
                <img
                  className="rounded-circle header-profile-user"
                  src={user?.avatar}
                  alt="Header Avatar"
                />
              ) : (
                <ConfigProvider colors={["red", "green", "blue"]}>
                  <Avatar
                    maxInitials={1}
                    round={true}
                    size="22"
                    name={user?.displayName}
                  />
                </ConfigProvider>
              )}
            </button>
          </div>
        </div>
      </div>
      {isShowAccountDropdown && (
        <DropdownMenu setIsShowAccountDropdown={setIsShowAccountDropdown} />
      )}
    </>
  );
}

export default LandingPageHeader;
